// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieConsent from "./components/CookieConsent";

// Code-splitting страниц
const Home = lazy(() => import("./pages/Home"));
const Products = lazy(() => import("./pages/Products"));
const Blog = lazy(() => import("./pages/Blog"));
const Admin = lazy(() => import("./pages/Admin"));
const Post = lazy(() => import("./pages/Post"));
const Cooperate = lazy(() => import("./pages/Cooperate"));
const Services = lazy(() => import("./pages/Services"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const About = lazy(() => import("./pages/About"));
const Contacts = lazy(() => import("./pages/Contacts"));
const Faq = lazy(() => import("./pages/Faq"));
const Cases = lazy(() => import("./pages/Cases"));
const FlyForecastCase = lazy(() => import("./pages/FlyForecastCase"));
const AiImplementationSakhalin = lazy(() => import("./pages/AiImplementationSakhalin"));
const AiConsultingSakhalin = lazy(() => import("./pages/AiConsultingSakhalin"));
const AiAuditBusiness = lazy(() => import("./pages/AiAuditBusiness"));
const AiTrainingEmployees = lazy(() => import("./pages/AiTrainingEmployees"));
const AiBotsDevelopment = lazy(() => import("./pages/AiBotsDevelopment"));
const ChatAiBotProduct = lazy(() => import("./pages/ChatAiBotProduct"));
const VoiceAiBotProduct = lazy(() => import("./pages/VoiceAiBotProduct"));
const RagSearchProduct = lazy(() => import("./pages/RagSearchProduct"));
const TelegramRagBotProduct = lazy(() => import("./pages/TelegramRagBotProduct"));
const RagImplementation = lazy(() => import("./pages/RagImplementation"));
const KnowledgeBaseAiSolution = lazy(() => import("./pages/KnowledgeBaseAiSolution"));
const SolutionPage = lazy(() => import("./pages/SolutionPage"));

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col transition-colors">
        <Header />
        <main id="main" className="flex-1 pt-20 overflow-x-hidden">
          <Suspense
            fallback={
              <div className="max-w-5xl mx-auto px-4 py-10">
                <div className="h-6 w-40 rounded shimmer bg-gray-200 dark:bg-gray-800" />
                <div className="mt-4 h-20 rounded shimmer bg-gray-200 dark:bg-gray-800" />
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/cooperate" element={<Cooperate />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/ai-implementation-sakhalin" element={<AiImplementationSakhalin />} />
              <Route path="/services/ai-consulting-sakhalin" element={<AiConsultingSakhalin />} />
              <Route path="/services/ai-audit-business" element={<AiAuditBusiness />} />
              <Route path="/services/ai-training-employees" element={<AiTrainingEmployees />} />
              <Route path="/services/ai-bots-development" element={<AiBotsDevelopment />} />
              <Route path="/services/rag-implementation" element={<RagImplementation />} />
              <Route path="/products/chat-ai-bot" element={<ChatAiBotProduct />} />
              <Route path="/products/voice-ai-bot" element={<VoiceAiBotProduct />} />
              <Route path="/products/rag-search" element={<RagSearchProduct />} />
              <Route path="/products/telegram-rag-bot" element={<TelegramRagBotProduct />} />
              <Route path="/solutions/knowledge-base-ai" element={<KnowledgeBaseAiSolution />} />
              <Route path="/solutions/sales-ai" element={<SolutionPage />} />
              <Route path="/solutions/support-ai" element={<SolutionPage />} />
              <Route path="/solutions/lead-processing-ai" element={<SolutionPage />} />
              <Route path="/solutions/document-flow-ai" element={<SolutionPage />} />
              <Route path="/solutions/hr-ai" element={<SolutionPage />} />
              <Route path="/solutions/marketing-ai" element={<SolutionPage />} />
              <Route path="/solutions/legal-ai" element={<SolutionPage />} />
              <Route path="/about" element={<About />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/cases" element={<Cases />} />
              <Route path="/cases/flyforecast" element={<FlyForecastCase />} />
              <Route path="/blog/:slug" element={<Post />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
